module.exports = __webpack_public_path__ + "media/images/landing/bg/case-johany/instagram-2-dfe000bfa5bf81e0da65ed027782e7ad.jpg";